﻿import React from "react";
import useAsync from "../../utils/useAsync.js";
import { getModelInputs } from "../../utils/companyApi.js";
import { fmtCell } from "../../utils/format.js";
import { Loading } from "./common.jsx";

export default function EstimatesTab({ ticker }) {
  const { data, loading, error } = useAsync(() => getModelInputs(ticker), [ticker]);
  if (loading) return <Loading />;
  if (error || !data || data.error) {
    return <div className="card co-card"><p className="co-hint">No SEC financials for this company, so there is no history to show.</p></div>;
  }
  const years = data.annual;
  const row = (label, key, kind, cls) => (
    <tr className={cls}>
      <td className="co-sticky">{label}</td>
      {years.map((y) => <td key={y.label}>{fmtCell(y[key], kind, "MM")}</td>)}
    </tr>
  );

  return (
    <div>
      <div className="card co-card co-table-wrap">
        <h6 className="co-card-title">Reported results by fiscal year ($MM, EPS in $)</h6>
        <table className="co-table">
          <thead><tr><th className="co-sticky" />{years.map((y) => <th key={y.label}>{y.label}</th>)}</tr></thead>
          <tbody>
            {row("Revenue", "revenue", "money")}
            {row("Revenue growth", "revG", "pct", "italic")}
            {row("EBITDA", "ebitda", "money")}
            {row("Net income", "ni", "money")}
            {row("EPS", "eps", "ps", "bold")}
            {row("Free cash flow", "fcf", "money")}
          </tbody>
        </table>
        <p className="co-hint">From SEC filings. Per-share figures are as originally reported, so years before a stock split are not adjusted.</p>
      </div>
      <div className="card co-card">
        <p className="co-hint">
          Forward estimates (analyst consensus for revenue and EPS, the number of analysts, and earnings surprises) come from
          brokerage research that data vendors sell under licence. There is no free source, so they are not shown.
          You can build your own forecast in the Model tab.
        </p>
      </div>
    </div>
  );
}
